<div class="help-container ion-page">
  <ion-list class="list">
    <ion-item lines="none">
      <ion-button slot="start"
        (click)="onCancelButtonClick()"
        color="light"
        shape="round"
        class="modal-up-button">
        <i class="far fa-times-circle icon"></i>
        <span>Cancel</span>
      </ion-button>

      <ion-text class="help-header">Help</ion-text>
    </ion-item>
  </ion-list>

  <ion-item class="help-scroll-content">
    <div>
      <p>
        <strong>Support Contacts</strong>
        <br><strong> Phone:</strong> 1-877-450-6534
        <br><strong> Email:</strong> promo.support&#64;sonymusic.com
      </p>

      <strong> What is the Promo Portal?</strong>
      <p>The Sony Music Digital Delivery promotional
        portal is a way for you to get the latest music from Sony Music labels. It's an app for mobile, tablet &
        desktop that's designed to deliver music digitally to individuals from labels in a faster, secure and more
        efficient way. </p>
      <p>The concept is simple. We notify you via email that a new single or album is available and you can click on
        the promo portal button or the e-card
        button or the download button in that email to open the e-card or register to promo portal or to download
        music using your PC. Each
        delivery is assigned to a specific person and has a limited number of downloads (3 by default) which can be
        changed by the promotional
        rep. When you have reached the maximum number of downloads you will have to send a request to the promotional
        rep asking to extend
        it.</p>
      <p>We hope that this digital
        delivery will let you put our records on air faster than ever. No more waiting for a Fed Ex package or courier
        deliveries. No more
        lost packages. </p>

      <strong>Why did you send it to me?</strong>
      <p> You are currently on our mailing list to get promotional music mailed to you or delivered by
        a Sony Music label promotion rep.</p>

      <strong> How can I be removed from the mailing list? </strong>
      <p>Contact us at promo.support&#64;sonymusic.com to let us know
        that you'd rather not get these emails and we'll take you off the list. But we hope you'll give this new
        delivery process a chance
        because it's how we intend to deliver music to radio in the future.</p>

      <strong>This is great, but you sent it to the wrong person! Who should I
        contact to update your mailing list?</strong>
      <p>You can reply to the email message or contact us at promo.support&#64;sonymusic.com</p>

      <strong> Will I still get CDs sent to me? </strong>
      <p>Yes. But we do intend to send fewer and fewer promo CDs via the mail.</p>

      <strong>What should I do with this thing that I downloaded?</strong>
      <p> The file you've downloaded is a ZIP file which contains your MP3, ASX streaming
        link, and any additional uploaded assets which may be a PDF, JPEG. The MP3 or streaming link you can give to
        your engineer to put into
        your station's music library. If you have an MP3 player (like Windows Media Player or WinAmp or MusicMatch) on
        your PC, or iTunes on your Mac, you can
        also
        listen to this track on your computer (see below for recommended hardware and software).</p>

      <strong>What do I need to play it?</strong>
      <p> We recommend a PC with
        Windows 98 or higher, or a Mac with iTunes. You should also have a sound card and external speakers. This is a
        high quality file and you'll want good
        speakers to hear it right. For Windows, we also suggest a digital music player like Microsoft's Windows Media
        Player, WinAmp or MusicMatch.</p>
      <p>Typically, a 3-4 minute song will take you under 2 minutes to download on a fast network connection. Using a
        56k modem, it could
        take
        you up to 20 minutes.</p>
      <p>Also you have the option to stream it on the app if you do not want to download it.</p>

      <strong>Can I forward this email to my engineer? Can I forward it to someone at our sister station?</strong>
      <p>You can forward the mail within your station once but remember that there are a limited
        number of downloads (3 by default). You should NOT forward it to another station if you think they should get
        the track, contact us
        (promo.support&#64;sonymusic.com). Also the
        person
        to whom you have forwarded might require an approval from the promotional rep to access it. But we hope you'll
        give this new
        delivery
        process a chance because it's how we intend to deliver music to radio in the future.</p>

      <strong> The link is broken or won't let me download it anymore. What should I do?</strong>
      <p>If you've downloaded the song more than 3 times or if it just doesn't work, you'll need to contact us to
        have another card sent out. If you can't even get the card to appear, you should send an email reply or
        contact us directly.</p>
      <p> If you got this link via a forwarded email, the link may not work. You should contact us to get signed up
        for digital delivery
        yourself.</p>

      <strong>How good is this file? Is it CD quality?</strong>
      <p> The file has been compressed to save you time in downloading but the quality is quite high. In
        our tests, nearly all our listeners were unable to tell the difference between a CD and this digital file.</p>

      <strong> What if I need a different format? </strong>
      <p>This is our preferred format but we are open to other formats that will work for our customers. Reply to the
        email you
        received (promo.support&#64;sonymusic.com) or contact us directly and tell us what formats you'd prefer and we'll
        look into them.
        There
        may be a more direct way for us to interact with your automated station software and we want to hear from
        you. </p>

      <strong>We already have a
        digital file system at my station. Why do I need this too?</strong>
      <p>If you are using a digital file system like Prophet, talk to your engineer
        about using this file. You can also use the file to preview the song and make decisions around adding it to
        your rotation.</p>

      <strong>How/Where can I find the file I downloaded?</strong>
      <p>If you clicked "OK" to download the file to the default directory, the music has been downloaded to
        your default download folder. You may also choose another folder on your computer if you would rather put the
        music somewhere
        else.</p>

      <strong> What player do you recommend I use to listen to the Music? </strong>
      <p>The Windows Media Player is included with most PCs or you can download it
        from Microsoft's site. On a Mac you can use iTunes, which is pre-installed.</p>

      <strong> Why did I get a "we are unable to save this file to this location" error? </strong>
      <p>That error occurs when the promotion
        card doesn't have the correct permission to write to your hard drive in that location. This sometimes happens
        on large corporate
        networks to protect you from installing software. Contact your System Administrator to fix this for you or you
        can choose to save
        the
        file to a new location.</p>
      <p> Current Promo Portal version: {{getAppVersion}}</p>
    </div>
  </ion-item>
</div>
